module.exports = __webpack_public_path__ + "i18n/fr.dce8daf6300f6ccaca88cbf552a14874.json";